/* cf-calc-memory.js - Click Fencing
 * Remember a customer's fence while their browser is open, and give them a way to start over.
 *
 * WHY: nothing was saved. Verified on the live site 2026-08-28 - configure a fence on
 * /pages/perfmesh-fence, navigate away, come back: zero storage keys written, the
 * calculator is back on step 1 and every entry is gone. Same on all calculators.
 *
 * WHAT: snapshot every form control on the calculator page into sessionStorage (Pete's
 * choice: kept until the browser closes, not longer), replay it on return, and add a
 * "Start again" button that clears the snapshot and reloads.
 *
 * HOW IT REPLAYS: the three aluminium/mesh calculator instances are closed over and
 * unreachable, so this drives the real controls exactly as a customer would - set
 * #sections-count, advance to Configure, then set each field and fire input+change.
 * Never assign calculator state directly; that leaves dependent fields unset and
 * manufactures bugs (see the click-fencing-calculators skill).
 */
(function () {
  if (window.__cfCalcMemoryInstalled) return;
  window.__cfCalcMemoryInstalled = true;

  var KEY     = 'cf-calc:' + location.pathname.replace(/\/+$/, '');
  var VERSION = 1;
  var SAVE_DEBOUNCE = 400;
  var restoring = false;

  function root() { return document.querySelector('.calculator-page'); }
  function controls() {
    var r = root(); if (!r) return [];
    return [].slice.call(r.querySelectorAll('input,select,textarea'))
             .filter(function (e) { return e.type !== 'file' && e.type !== 'submit' && e.type !== 'button' && !/^Search/.test(e.id || ''); });
  }
  function activeTab() {
    var t = document.querySelector('.calculator-page .tab-content.active');
    return t ? t.id : null;
  }

  /* ---------------- capture ---------------- */
  function snapshot() {
    var byId = {}, byName = {}, els = controls();
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.type === 'radio') {
        if (e.checked && e.name) byName[e.name] = e.id || e.value;
        if (e.id) byId[e.id] = e.checked;
      } else if (e.type === 'checkbox') {
        if (e.id) byId[e.id] = e.checked;
      } else if (e.id) {
        byId[e.id] = e.value;
      }
    }
    var sc = document.querySelector('#sections-count');
    return { v: VERSION, ts: Date.now(), path: location.pathname,
             sectionsCount: sc ? sc.value : null, tab: activeTab(),
             byId: byId, byName: byName };
  }

  function hasContent(s) {
    if (!s) return false;
    if (s.sectionsCount && String(s.sectionsCount).trim() !== '') return true;
    for (var k in s.byId) if (/-length$/.test(k) && s.byId[k]) return true;
    return false;
  }

  var saveTimer = null;
  function save() {
    if (restoring) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try {
        var s = snapshot();
        if (!hasContent(s)) return;
        sessionStorage.setItem(KEY, JSON.stringify(s));
        showBar(true);
      } catch (e) {}
    }, SAVE_DEBOUNCE);
  }

  /* ---------------- replay ---------------- */
  function fire(el, kinds) {
    for (var i = 0; i < kinds.length; i++) {
      try { el.dispatchEvent(new Event(kinds[i], { bubbles: true })); } catch (e) {}
    }
  }
  function setValue(el, val) {
    if (el.type === 'checkbox' || el.type === 'radio') {
      var want = (val === true || val === 'true');
      if (el.checked !== want) { el.click(); return true; }         // click so the app's handler runs
      return false;
    }
    if (String(el.value) !== String(val)) { el.value = val; fire(el, ['input', 'change']); return true; }
    return false;
  }

  function applyPass(s) {
    var changed = 0, els = controls();
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.id && Object.prototype.hasOwnProperty.call(s.byId, e.id)) {
        if (setValue(e, s.byId[e.id])) changed++;
      } else if (e.type === 'radio' && e.name && s.byName[e.name] !== undefined) {
        var want = (s.byName[e.name] === (e.id || e.value));
        if (e.checked !== want && want) { e.click(); changed++; }
      }
    }
    return changed;
  }

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  async function restore(s) {
    restoring = true;
    try {
      var sc = document.querySelector('#sections-count');
      if (sc && s.sectionsCount) { sc.value = s.sectionsCount; fire(sc, ['input', 'change']); }
      await sleep(500);

      // advance to Configure so every section's controls exist
      var next = [].slice.call(document.querySelectorAll('.calculator-page button, .calculator-page a'))
                   .filter(function (b) { return /^next/i.test((b.textContent || '').trim()); })[0];
      if (next) next.click();
      await sleep(900);

      // conditional fields appear as their parent toggle flips, so repeat until settled
      for (var pass = 0; pass < 6; pass++) {
        var n = applyPass(s);
        await sleep(n ? 450 : 250);
        if (!n && pass > 1) break;
      }

      if (s.tab) {
        var tab = document.getElementById(s.tab);
        if (tab && !tab.classList.contains('active')) {
          var link = document.querySelector('[data-tab="' + s.tab + '"], [href="#' + s.tab + '"]');
          if (link) link.click();
        }
      }
      console.log('[cf-calc-memory] restored');
      window.__cfCalcMemoryState = 'done';
    } catch (e) {
      console.log('[cf-calc-memory] restore failed', e);
    }
    restoring = false;
    if (window.__cfCalcMemoryState !== 'done') window.__cfCalcMemoryState = 'failed';
    try { document.dispatchEvent(new CustomEvent('cf-calc-memory:restored')); } catch (e) {}
    save();
  }

  /* ---------------- start again ---------------- */
  function startAgain() {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    location.href = location.pathname;   // drop any query string, full reload
  }

  var bar = null;
  function showBar(saved) {
    if (!bar) return;
    bar.style.display = saved ? 'flex' : 'none';
  }

  function buildBar() {
    var host = document.querySelector('.calculator-page .calculator-content') || root();
    if (!host || document.getElementById('cf-calc-memory-bar')) return;
    bar = document.createElement('div');
    bar.id = 'cf-calc-memory-bar';
    bar.style.cssText = 'display:none;align-items:center;gap:10px;justify-content:flex-end;' +
      'padding:6px 16px 0;font-size:13px;color:#475569;flex-wrap:wrap';
    var note = document.createElement('span');
    note.textContent = 'Your fence is saved while this browser is open.';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'cf-start-again';
    btn.textContent = 'Start again';
    btn.style.cssText = 'border:1px solid #cbd5e1;background:#fff;color:#0f172a;border-radius:8px;' +
      'padding:7px 14px;font-size:14px;font-weight:600;cursor:pointer;line-height:1.2;min-height:36px';
    btn.addEventListener('click', function () {
      if (confirm('Start again? This clears the fence you have configured on this page.')) startAgain();
    });
    bar.appendChild(note); bar.appendChild(btn);
    host.insertBefore(bar, host.firstChild);
  }

  /* ---------------- boot ---------------- */
  function boot() {
    if (!root()) return false;
    buildBar();
    var r = root();
    r.addEventListener('input', save, true);
    r.addEventListener('change', save, true);
    r.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('input,select,button,[role="switch"],label')) save();
    }, true);

    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (saved && saved.v === VERSION && hasContent(saved)) {
      showBar(true);
      window.__cfCalcMemoryState = 'restoring';
      restore(saved);
    }
    if (!window.__cfCalcMemoryState) window.__cfCalcMemoryState = 'none';
    console.log('[cf-calc-memory] installed');
    return true;
  }

  function waitForCalc() {
    var n = 0;
    var t = setInterval(function () {
      if (boot() || ++n > 40) clearInterval(t);
    }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', waitForCalc);
  else waitForCalc();
})();
